import { render, staticRenderFns } from "./changepswPage.vue?vue&type=template&id=491869ec&scoped=true"
import script from "./changepswPage.vue?vue&type=script&lang=js"
export * from "./changepswPage.vue?vue&type=script&lang=js"
import style0 from "./changepswPage.vue?vue&type=style&index=0&id=491869ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491869ec",
  null
  
)

export default component.exports